import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { RecommendationSourceObjectType } from '@udemy-v2/react-recommendations';
import { LimitedAccessRecommendationsWrapper } from './limited-access-recommendations-wrapper.react-component';
import { LimitedAccessRecommendationsCarousel } from './limited-access-recommendations-carousel.react-component';
export interface UnavailableCourseTopicProps {
  /** Topic id sourced from the ACCESS_RESTRICTED extension. */
  topicId?: string;
}
interface UnavailableCourseTopicRecommendationsWrapperProps extends UnavailableCourseTopicProps {
  children: React.ReactNode;
}

/**
 * Topic-flavored wrapper around LimitedAccessRecommendationsWrapper.
 * Returns null when topicId is missing.
 */
export const UnavailableCourseTopicRecommendationsWrapper = t0 => {
  const $ = _c(5);
  const {
    topicId,
    children
  } = t0;
  let t1;
  if ($[0] !== topicId) {
    t1 = topicId ? [{
      id: topicId,
      type: RecommendationSourceObjectType.Label
    }] : [];
    $[0] = topicId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sourceObjects = t1;
  let t2;
  if ($[2] !== children || $[3] !== sourceObjects) {
    t2 = <LimitedAccessRecommendationsWrapper sourceObjects={sourceObjects} contextId="disabled_course_label">{children}</LimitedAccessRecommendationsWrapper>;
    $[2] = children;
    $[3] = sourceObjects;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const UnavailableCourseTopicCarousel = t0 => {
  const $ = _c(3);
  const {
    topicId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LimitedAccessRecommendationsCarousel />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== topicId) {
    t2 = <UnavailableCourseTopicRecommendationsWrapper topicId={topicId}>{t1}</UnavailableCourseTopicRecommendationsWrapper>;
    $[1] = topicId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};